// const config = {
//     BASE_URI: `${process.env.REACT_APP_BASE_URI}`,

// };
// export default config;


//Added
const config = {
  BASE_URI: process.env.REACT_APP_BASE_URI || "http://localhost:8000", // fallback for local dev
  S3_BASE_URI: process.env.REACT_APP_S3_BASE_URI || "",
};



export default config;
